module.exports = __webpack_public_path__ + "assets/best-sales-recruiters-phoenix-2.97257b1e.png";